// extracted by mini-css-extract-plugin
export default {"container":"MxFR","children":"iJul","trigger":"AYfX"};